import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Loading from '../../Components/loading/Loading'

import Subscribe from '../pages-management/subscribe/Subscribe'

import './styles.scss'
import { SettingsTabs, TabList } from './types'
import InformationTab from './tabs/InformationTab'
import PreferencesTab from './tabs/PreferencesTab'
import IntegrationsTab from './tabs/IntegrationsTab'
import PagesTab from './tabs/PagesTab'
import DataTab from './tabs/DataTab'
import { requestSettings } from '../../store/settings/actions'
import { Plann3rStore } from '../../store/types'
import { SettingsStore } from '../../store/settings/types'
import { showHeader } from '../../store/general/actions'

const Settings: FC = () => {
  const dispatch = useDispatch()

  const { isFetching } = useSelector((state: Plann3rStore): SettingsStore => state.settings)
  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.settings.settings,
  )

  const [currentTab, setcurrentTab] = useState(SettingsTabs.INFORMATION)
  const [showSubscriptionPopup, setshowSubscriptionPopup] = useState(false)

  useEffect(() => {
    dispatch(requestSettings())
    dispatch(showHeader(true))
  }, [dispatch])
  
  const tabs: TabList[] = [
    {
      id: SettingsTabs.INFORMATION,
      label: strings.labels.information,
    },
    {
      id: SettingsTabs.PREFERENCES,
      label: strings.labels.preferences,
    },
    {
      id: SettingsTabs.INTEGRATIONS,
      label: strings.labels.integrations,
    },
    {
      id: SettingsTabs.PAGES,
      label: strings.labels.pages,
    },
    {
      id: SettingsTabs.DATA,
      label: strings.labels.data,
    },
  ]

  const finishedSubscription = () => {
    setshowSubscriptionPopup(false)

    window.location.reload()
  }

  const toggleClose = () => {
    setshowSubscriptionPopup(false)
  }

  const renderTab = () => {
    switch (currentTab) {
      case SettingsTabs.INFORMATION:
        return <InformationTab showSubscriptionPopup={() => setshowSubscriptionPopup(true)} />
      case SettingsTabs.PREFERENCES:
        return <PreferencesTab />
      case SettingsTabs.INTEGRATIONS:
        return <IntegrationsTab showSubscriptionPopup={() => setshowSubscriptionPopup(true)} />
      case SettingsTabs.PAGES:
        return <PagesTab />
      case SettingsTabs.DATA:
        return <DataTab />
      default:
        return null
    }
  }

  const renderTabMenuLink = (tab: TabList) => {
    const className = currentTab === tab.id ? 'is-active' : ''
    return (
      <li key={tab.id}>
        <a
          href={tab.id === 'pages' ? '/pages' : '#' + tab.id}
          className={className}
          onClick={() => setcurrentTab(tab.id)}
        >
          {tab.label}
        </a>
      </li>
    )
  }

  if (isFetching) {
    return (
      <div>
        <Loading />
      </div>
    )
  }
  return (
    <div className="columns settings">
      <div className="column is-one-quarter">
        <aside className="menu">
          <h2>{strings.settings}</h2>
          <ul className="menu-list">{tabs.map(renderTabMenuLink)}</ul>
        </aside>
      </div>
      <div className="column">
        {renderTab()}
        <div className={'modal' + (showSubscriptionPopup ? ' is-active' : '')}>
          <div className="modal-background" onClick={toggleClose} role="presentation" />
          <Subscribe afterSubmit={finishedSubscription} />
          <button className="modal-close" onClick={toggleClose} />
        </div>
      </div>
    </div>
  )
}
export default Settings
